import { createApp } from 'vue';
import PptxToPngConverter from '@/Components/PptxToPngConverter.vue';
import '@styles/app.css';

createApp(PptxToPngConverter).mount('#pptx-to-png-converter');
